
import React from 'react';
import { cn } from "@/lib/utils";
import ChatbotAvatar from './ChatbotAvatar';

export type MessageType = 'user' | 'assistant';

export interface ChatMessageProps {
  type: MessageType;
  content: string;
  isTyping?: boolean;
}

const ChatMessage: React.FC<ChatMessageProps> = ({ 
  type, 
  content,
  isTyping = false
}) => {
  const isUser = type === 'user';
  
  return (
    <div className={cn(
      "flex w-full gap-2 items-start mb-4",
      isUser ? "justify-end" : "justify-start"
    )}>
      {!isUser && <ChatbotAvatar speaking={isTyping} />}
      
      <div className={cn(
        "max-w-[80%] rounded-lg px-4 py-2",
        isUser 
          ? "bg-primary text-primary-foreground" 
          : "bg-muted"
      )}>
        {content}
        {isTyping && (
          <span className="inline-block animate-pulse ml-1">...</span>
        )}
      </div>
      
      {isUser && (
        <div className="w-8 h-8 rounded-full bg-secondary flex items-center justify-center text-secondary-foreground">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5">
            <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
            <circle cx="12" cy="7" r="4" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default ChatMessage;
